import { useLocation } from 'react-router-dom';
import { isProjectSettingsPath } from '@/versions/v1/shared/project-sidebar-nav';
import { useRole } from '@/versions/v1/shared/RoleContext';
import { AdminSidebar } from './sidebar/AdminSidebar';
import { SettingsSidebar } from './sidebar/SettingsSidebar';
import { ThreadHistorySidebar } from './sidebar/ThreadHistorySidebar';

export function AppSidebar() {
  const { pathname } = useLocation();
  const { can } = useRole();
  const isAdmin = can('roles:admin');

  if (pathname.startsWith('/admin')) {
    return isAdmin ? <AdminSidebar /> : <ThreadHistorySidebar />;
  }
  if (pathname.startsWith('/settings') && !isProjectSettingsPath(pathname)) {
    return <SettingsSidebar />;
  }
  return <ThreadHistorySidebar />;
}
